import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-addnewparameterconfig',
  templateUrl: './addnewparameterconfig.component.html',
})
export class AddnewparameterconfigComponent implements OnInit {
  Formula: string = '';
  isForViewFormula: boolean = false;
  isDisplayFormula: boolean = false;
  ParameterList: any = [];
  parameterconfigform: FormGroup;
  EnergyMeterList = [];
  errorMsg: string = '';
  successMsg: string = '';
  meterId: any = '';
  EnergymeterName: any;
  RegisterData: any;
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  ParameterConfigId: any;
  RegisterName: any;
  TempFormula: any;
  TagId: any;
  title: any = 'Parameter Configuration';
  Register: any;
  selectedmetername: any;
  meterid: any;
  IsFromParameterConfig: any;
  constructor(
    public dialogRef: MatDialogRef<AddnewparameterconfigComponent>,
    private commonservice: CommonService,
    private GSMConfigService: GSMConfigurationService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedmetername = data.selectedmetername;
    this.meterid = data.id;
    if (data && data.IsForview == 'Y') {
      this.isForViewFormula = true;
      this.Formula = data.Formula;
      this.title = 'View Formula';
    }
    if (data && data.IsForview == 'N') {
      this.ParameterConfigId = this.data.data;
      this.RegisterName = this.ParameterConfigId
        ? this.ParameterConfigId.value.RegisterName
        : this.data.data.RegisterName;
      this.TempFormula = this.ParameterConfigId
        ? this.ParameterConfigId.value.TempFormula
        : this.data.data.TempFormula;
      this.TagId = this.ParameterConfigId
        ? this.ParameterConfigId.value.TagId
        : this.data.data.TagId;
      this.title = 'Parameter Configuration';
    }
    this.authService.getValidationMessage().subscribe((resp) => {
      this.validationMessages = resp.parameterconfigform;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    if (this.data.data.value) {
      this.isDisplayFormula = true;
    }

    this.meterId = this.meterid;
    this.EnergymeterName = this.selectedmetername;
    setTimeout(() => {
      this.GetRegisterdata(this.meterId);
    }, 1500);
    this.parameterconfigform = this.formBuilder.group({
      RegisterDataId: ['', [Validators.required]],
      Formula: [''],
      RegisterName: [''],
    });

    this.getEnergyMeterData();
    this.GetRegisterdata(this.meterId).subscribe(() => {
      if (this.ParameterConfigId.value.RegisterNO > 0) {
        this.isDisplayFormula = true;
        //  this.meterId = this.data.data.EnergymeterMasterId.toString();
        const formula = this.ParameterConfigId.value.Formula;
        const splitFormula = formula.split(/([+\-*/])/);
        const TempFormula = this.TempFormula.split(/([+\-*/])/);
        const prefix = 'PC';
        const result = [];
        let prefixIndex = 1;
        const regex = /##(.*?)#/g;
        const tags = [];

        let match;
        while ((match = regex.exec(this.TagId))) {
          const tag = match[1];
          tags.push(tag);
        }
        var item1;
        for (let i = 0; i < TempFormula.length; i++) {
          for (let j = 0; j < splitFormula.length; j++) {
            item1 = splitFormula[i];
          }
          const item = TempFormula[i];
          if (/\w+/.test(item) && item.includes('PC')) {
            result.push({
              RegisterName: item1,
              PcName: `${prefix}${prefixIndex}`,
            });
            prefixIndex++;
          }
        }

        result.forEach((element: any, i: number) => {
          var rname = this.RegisterData.filter(r => r.TagId == tags[i])[0].RegisterName;
          this.ParameterList.push({
            MeterName: this.EnergymeterName,
            RegisterNo: element.PcName,
            RegisterName: rname,
            RegisterDataId: this.parameterconfigform.value.RegisterDataId,
            TagId: tags[i],
          });
        });

        this.parameterconfigform.controls['RegisterName'].patchValue(
          this.RegisterName
        );
        this.parameterconfigform.controls['Formula'].patchValue(
          this.TempFormula
        );
      }
    });

    // Call service for validation on valu change
    this.parameterconfigform.valueChanges.subscribe(
      (value) =>
        (this.displayMessage = this.genericValidator.processMessages(
          this.parameterconfigform
        ))
    );
  }

  // Get Energy Meter Data
  getEnergyMeterData() {
    this.commonservice.GetEnergyMeterIdList(0, 0, 'N').subscribe(
      (result) => {
        this.EnergyMeterList = result;
        if (this.meterId) {
          this.EnergyMeterList.forEach((option) => {
            if (this.meterId == option.CodeValue) {
              option.isDisabled = false;
            } else {
              option.isDisabled = true;
            }
          });
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  DeleteParamterData(index: number) {
    this.errorMsg = '';
    this.successMsg = '';
    this.ParameterList.splice(index, 1);
    if (this.ParameterList.length == 0) {
      this.EnergyMeterList.forEach((option) => {
        option.isDisabled = false;
      });
    }
  }

  OnChangeRegister(event) {
    this.Register = event.source.triggerValue;
  }
  // Formula validation function
  CheckForFormula(Formula: string) {
    // Match all occurrences like PC1, PC2, etc.
    const matches = Formula.match(/PC\d+/g) || [];

    // Create a Set for uniqueness
    const uniquePCs = [...new Set(matches)];

    // Compare against ParameterList
    const paramRegisterNos = this.ParameterList.map((p) => p.RegisterNo);

    // Check if all ParameterList PCs are present in the formula
    const missingRegisters = paramRegisterNos.filter(
      (pc) => !uniquePCs.includes(pc)
    );

    if (uniquePCs.length > paramRegisterNos.length) {
      this.errorMsg = 'Formula Invalid, Please enter valid formula.';
      return;
    } else if (missingRegisters.length > 0) {
      this.errorMsg =
        'Include all the registers or delete them from the list if not needed';
      return;
    }

    this.errorMsg = ''; // No errors
  }
  // Get Register Data
  GetRegisterdata(id): Observable<any> {
    return this.GSMConfigService.GetRegisterdata(id, 'N', '', '').pipe(
      tap((result) => {
        if (result.listRegisterdata != null) {
          this.RegisterData = result.listRegisterdata;
          this.RegisterData.forEach((option) => {
            if (option.TagId == 'DataCount') {
              option.isDisabled = true;
            }
          });
        }
      }),
      catchError((error) => {
        this.errorMsg = error;
        return of(null); // or throwError if you want to rethrow
      })
    );
  }

  // Close Icon event
  Close() {
    this.dialogRef.close();
  }

  AddRegisters() {
    this.errorMsg = '';
    this.successMsg = '';
    if (this.parameterconfigform.invalid) {
      this.parameterconfigform.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(
        this.parameterconfigform
      );
      return;
    }

    var existRegister = this.ParameterList.filter(
      (p) => p.RegisterName == this.Register
    );

    if (existRegister && existRegister.length > 0) {
      this.errorMsg = 'Same Register already added in list!!';
      return;
    }

    var PCindex = 0;
    if (this.ParameterList == null) {
      PCindex = PCindex + 1;
    } else {
      PCindex = this.ParameterList.length + 1;
    }
    this.EnergyMeterList.forEach((option) => {
      if (this.meterId == option.CodeValue) {
        option.isDisabled = false;
      } else {
        option.isDisabled = true;
      }
    });

    var RegisterName = this.RegisterData.filter(
      (r) => r.RegisterDataId == this.parameterconfigform.value.RegisterDataId
    )[0].RegisterName;
    var RegisterTagId = this.RegisterData.filter(
      (r) => r.RegisterDataId == this.parameterconfigform.value.RegisterDataId
    )[0].TagId;
    this.ParameterList.push({
      MeterName: this.EnergymeterName,
      RegisterNo: 'PC' + PCindex,
      RegisterName: RegisterName,
      RegisterDataId: this.parameterconfigform.value.RegisterDataId,
      TagId: RegisterTagId,
    });
  }

  // Add Formula
  AddFormula() {
    this.isDisplayFormula = true;
  }

  // Save Parameter Config Data
  SaveParameterConfigData() {
    this.errorMsg = '';
    this.successMsg = '';

    var param = { ...this.parameterconfigform.value };

    var existRegisterName = this.ParameterList.filter(
      (p) => p.RegisterName == param.RegisterName
    );

    if (existRegisterName.length > 0) {
      this.errorMsg =
        'Register Name already added against same MeterId. Please change Register Name!!';
      return;
    }
    this.CheckForFormula(param.Formula);

    this.parameterconfigform.controls['Formula'].setValidators(
      Validators.required
    );
    this.parameterconfigform.controls['Formula'].updateValueAndValidity();
    this.parameterconfigform.controls['RegisterName'].setValidators([
      Validators.required,
    ]);
    this.parameterconfigform.controls['RegisterName'].updateValueAndValidity();

    if (this.ParameterConfigId) {
      this.parameterconfigform.controls['RegisterDataId'].clearValidators();
      this.parameterconfigform.controls[
        'RegisterDataId'
      ].updateValueAndValidity();
    }

    if (this.parameterconfigform.invalid) {
      this.parameterconfigform.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(
        this.parameterconfigform,
        true
      );
      return;
    }

    if (this.errorMsg == '') {
      var tagId = param.Formula;
      var registerFormula = param.Formula;
      this.ParameterList.forEach((element) => {
        tagId = tagId.replaceAll(
          element.RegisterNo,
          '##' + element.TagId + '#'
        );
        registerFormula = registerFormula.replaceAll(
          element.RegisterNo,
          element.RegisterName
        );
      });

      var reqObj = {
        RegisterDataId: this.ParameterConfigId ? this.ParameterConfigId : 0,
        RegisterName: param.RegisterName,
        EnergymeterMasterId: this.meterId,
        TagId: tagId,
        Formula: registerFormula,
        TempFormula: this.parameterconfigform.value.Formula,
        IsFromParameterConfig: 'Y',
        PCNo: this.ParameterList,
      };
      this.dialogRef.close(reqObj);
    }
  }
}
